module.exports = __webpack_public_path__ + "img/product-details-5.923977ee.jpg";